import * as yup from 'yup';

export const FIELD_APPLICATION = 'application';
export const FIELD_PIN = 'pin';
export const FIELD_FIRST_NAME = 'firstName';
export const FIELD_LAST_NAME = 'lastName';
export const FIELD_MIDDLE_NAME = 'surname';
export const FIELD_DIRECTION = 'direction';
export const FIELD_REGION = 'region';
export const FIELD_DISTRICT = 'district';
export const FIELD_DESCRIPTION = 'description';

export const AppealEditValidationForm = yup.object().shape({
  [FIELD_APPLICATION]: yup.string().required('error.required').trim(),
  [FIELD_PIN]: yup.string().required('error.required').trim(),
  [FIELD_FIRST_NAME]: yup.string().required('error.required').trim(),
  [FIELD_LAST_NAME]: yup.string().required('error.required').trim(),
  [FIELD_MIDDLE_NAME]: yup.string().required('error.required').trim(),
  [FIELD_DIRECTION]: yup.string().required('error.required').trim(),
  [FIELD_REGION]: yup.string().required('error.required').trim(),
  [FIELD_DISTRICT]: yup.string().required('error.required').trim(),
  [FIELD_DESCRIPTION]: yup.string().required('error.required').trim(),
});
